import React, { useEffect, useState } from "react";
import LoadingIndicator from "components/Reusable/LoadingIndicator";
import { ACTIVE_TAB, VARIANTS } from "configs/constants";
import EmptyList from "pages/flightList/flightsContainer/EmptyList";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { flightsListSelector } from "redux/slices/flightsList.slice";
import styled from "styled-components";

import List from "./flightsContainer/List";
import Header from "./Header";
import { NO_MATCH_MESSAGE_HEIGHT } from "./NoMatchMessage";

const FlightsList = ({
  flights = [],
  unfilteredFlights = [],
  areFlightsLoading,
  terminal,
  hasSearched,
  terminalsDropdownOptionList,
  setQueryParams,
}) => {
  const { t } = useTranslation();
  const { activeTab } = useSelector(flightsListSelector);

  const noFlights = !unfilteredFlights.length && !flights.length;
  const noFavoriteFlights =
    activeTab === ACTIVE_TAB.FAVORITES && !flights.length;
  const noTerminalFlights = !flights.length && unfilteredFlights.length;

  const flightsToRender = noTerminalFlights ? unfilteredFlights : flights;

  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = ({ scrollTop }) => {
    setScrollPosition(scrollTop);
  };

  const [spacerHeight, setSpacerHeight] = useState(0);

  useEffect(() => {
    //COMPUTE SPACER HEIGHT
    const headerElement = document.getElementById("header");
    if (headerElement) {
      const { height } = headerElement.getBoundingClientRect();

      if (noTerminalFlights) {
        setSpacerHeight(height + NO_MATCH_MESSAGE_HEIGHT);
        return;
      }

      setSpacerHeight(height);
    }
  }, [hasSearched, noTerminalFlights, activeTab]);

  return (
    <StyledListContainer>
      <Header
        hasSearched={hasSearched}
        noTerminalFlights={noTerminalFlights}
        flightsCount={flightsToRender.length}
        scrollPosition={scrollPosition}
        terminal={terminal}
        setQueryParams={setQueryParams}
        terminalsOptionList={terminalsDropdownOptionList}
      />
      {areFlightsLoading && (
        <LoadingIndicator
          verticalOffset={spacerHeight}
          height="200px"
          variant={VARIANTS.LOADING_INDICATOR.ABSOLUTE}
        />
      )}
      {!areFlightsLoading && noFlights && (
        <EmptyList
          verticalOffset={spacerHeight}
          message={
            noFavoriteFlights
              ? t("flights_list.favorites_emptyList")
              : t("flights_list.emptyList")
          }
        />
      )}
      <List
        noFavoriteFlights={noFavoriteFlights}
        flightsToRender={flightsToRender}
        areFlightsLoading={areFlightsLoading}
        spacerHeight={spacerHeight}
        noTerminalFlights={noTerminalFlights}
        scrollPosition={scrollPosition}
        handleScroll={handleScroll}
        hasSearched={hasSearched}
        terminal={terminal}
      />
    </StyledListContainer>
  );
};

// ===========================
//    # Styled Components #
// ===========================

const StyledListContainer = styled.div`
  .containerList {
    overscroll-behavior-y: none;
    overscroll-behavior-x: none;
    -webkit-overscroll-behavior-y: none;
    -webkit-overscroll-behavior-x: none;
  }

  .containerList::-webkit-scrollbar {
    display: none;
  }
`;

export default FlightsList;
